<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom-narrow"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <div class="page-block__header">
                    <h1 class="page-block__title | u-font-weight-normal">{{ trans('page.security.title') }}</h1>
                </div>

                <div class="page-block | u-margin-bottom-narrow">
                    <div class="page-block__item-wrapper | u-flex-column">
                        <div class="layout">
                            <div class="layout__item u-3/4-desk">
                                <div class="u-margin-bottom-narrow">
                                    {{ trans('security.intro') }}
                                </div>

                                <security-overview
                                    v-if="!confirmEntity"
                                    :user="user"
                                    :loading="loading"
                                    :form="form"
                                    @checkAuthenticationCode="checkAuthenticationCode"
                                    @generateAuthenticationKey="generateAuthenticationKey"
                                    @resetAuthenticationKey="resetAuthenticationKey"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <confirmation-modal
            v-if="confirmEntity"
            :confirmEntity="confirmEntity"
            confirmMessage="security.confirm-removal"
            @confirm="confirmRemoval"
            @close="cancelRemoval"
        />
    </div>
</template>

<script>
import { ConfirmationModal } from 'relapp-confirm';
import { SecurityOverview, TwoFactorApi } from 'relapp-security';
import { pageLoadingStatusMixin } from 'relapp-loading';
import { apiMixin } from 'relapp-api';
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from 'relapp-event';
import { formMixin, Way2Form } from 'relapp-way2forms';

export default {
    components: {
        ConfirmationModal,
        SecurityOverview
    },
    /**
     * confirmEntity is used when the box is unchecked.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                code: null
            }),
            confirmEntity: ''
        };
    },
    mixins: [pageLoadingStatusMixin, apiMixin, formMixin],
    computed: {
        ...mapGetters({
            user: 'user/user'
        })
    },
    metaInfo: {
        title: trans('page.security.title')
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.finishLoading();
    },
    methods: {
        ...mapActions({
            set2faSecret: 'user/set2faSecret',
            set2faValidated: 'user/set2faValidated'
        }),
        /**
         * Call the endpoint to reset the password for an email.
         *
         * @param {object} form
         */
        checkAuthenticationCode(form) {
            this.startLoading();
            TwoFactorApi.check(form.data())
                .then(response => {
                    this.finishLoading();

                    if (response.data.valid) {
                        EventBus.$emit('notification', {
                            type: 'success',
                            message: trans('security.2fa-success')
                        });
                        this.set2faValidated(true);
                    } else {
                        EventBus.$emit('notification', {
                            type: 'error',
                            message: trans('security.2fa-failed')
                        });
                    }
                })
                .catch(error => {
                    this.showValidationErrors(error, form);
                })
                .then(this.finishLoading);
        },
        /**
         * Call the endpoint to generate the authentication key.
         */
        generateAuthenticationKey() {
            this.startLoading();
            this.set2faSecret(null);
            this.set2faValidated(false);

            TwoFactorApi.set().then(({ data }) => {
                this.set2faSecret(data['2fa_secret']);
                this.finishLoading();
            });
        },
        /**
         * Call the endpoint to reset the authentication key.
         */
        resetAuthenticationKey() {
            this.confirmEntity = '2-Factor authentication';
        },
        /**
         * Confirm resetting 2FA.
         */
        confirmRemoval() {
            this.confirmEntity = '';
            this.startLoading();
            this.set2faSecret(null);
            this.set2faValidated(false);

            TwoFactorApi.reset().then(() => {
                EventBus.$emit('notification', {
                    type: 'warning',
                    message: trans('security.2fa-reset')
                });
                this.finishLoading();
            });
        },
        /**
         * Cancel resetting 2FA
         */
        cancelRemoval() {
            this.confirmEntity = '';
        }
    }
};
</script>
